import { Ref, ref } from 'vue'
export default function usePagination<T>(
  initialRows: T[],
  totalRows: number = 0,
  rowsPerPage: number = 10
) {
  let rawRows: T[] = []
  let searchedRows: T[] = []
  let numberOfRows = 0
  const allPages = new Map<number, T[]>()
  const currentPage = ref(1)
  const totalPages = ref(1)

  const currentPageRows = ref<T[]>([]) as Ref<T[]>

  function updateRows(rows: T[], totalRows?: number) {
    rawRows = rows
    numberOfRows = totalRows || 0
    search('') // reset search
  }

  function setConfig(perPageNew: number, searchText: string = '') {
    rowsPerPage = perPageNew
    search(searchText)
  }

  function search(search: string, allConsulted?: boolean) {
    searchedRows = rawRows?.filter(row => {
      const searchTerm = search.toLowerCase()
      for (const key in row) {
        const value = String(row[key]).toLowerCase()
        if (value.includes(searchTerm)) {
          return true
        }
      }
      return false
    })

    if (
      numberOfRows > 0 &&
      numberOfRows > searchedRows.length &&
      !allConsulted
    ) {
      const emptyRowsCount = numberOfRows - searchedRows.length
      for (let i = 0; i < emptyRowsCount; i++) {
        searchedRows.push({} as T)
      }
    }
    paginate()
  }

  function paginate() {
    allPages.clear()
    let count = 1

    while (searchedRows?.length > 0 && rowsPerPage > 0) {
      const page = searchedRows.splice(0, rowsPerPage)
      allPages.set(count++, page)
    }
    currentPage.value = 1
    currentPageRows.value = allPages.get(currentPage.value) ?? []
    totalPages.value = allPages.size
  }

  function nextPage() {
    if (currentPage.value < allPages.size) {
      currentPage.value++
      currentPageRows.value = allPages.get(currentPage.value) ?? []
    }
  }

  function setPage(page: number) {
    if (page >= 1 && page <= allPages.size) {
      currentPage.value = page
      currentPageRows.value = allPages.get(currentPage.value) ?? []
    }
  }

  function prevPage() {
    if (currentPage.value > 1) {
      currentPage.value--
      currentPageRows.value = allPages.get(currentPage.value) ?? []
    }
  }

  function goToFirsPage() {
    currentPage.value = 1
    currentPageRows.value = allPages.get(currentPage.value) ?? []
  }

  function goToLastPage() {
    currentPage.value = allPages.size
    currentPageRows.value = allPages.get(currentPage.value) ?? []
  }

  updateRows(initialRows, totalRows) // init
  return {
    updateRows,
    rawRows,
    setConfig,
    search,
    currentPage,
    totalPages,
    currentPageRows,
    nextPage,
    prevPage,
    setPage,
    goToFirsPage,
    goToLastPage
  }
}
